// Duplicate detection helpers, shared between PropertiesTable and Dashboard.
//
// Two properties are compared on 6 fields. If 3+ fields match → "orange"
// (possibile duplicato). If ALL 6 match → "red" (duplicato completo).
// `venditore` is intentionally NOT included because the same physical
// property is often listed by multiple sellers.

export const DUP_FIELDS = ["indirizzo", "mq", "prezzo", "piano", "macro_area", "scostamento"];

export const normalizeAddress = (s) => {
  if (!s) return "";
  return String(s)
    .toLowerCase()
    .replace(/[.,;·]+/g, " ")
    .replace(/\s+/g, " ")
    .trim();
};

const fieldsMatch = (a, b, field) => {
  switch (field) {
    case "indirizzo":
      return !!a.indirizzo && !!b.indirizzo && normalizeAddress(a.indirizzo) === normalizeAddress(b.indirizzo);
    case "mq":
      return a.mq != null && b.mq != null && Number(a.mq) === Number(b.mq);
    case "prezzo":
      return a.prezzo != null && b.prezzo != null && Number(a.prezzo) === Number(b.prezzo);
    case "piano":
      return (a.piano || "").toString().trim().toUpperCase() === (b.piano || "").toString().trim().toUpperCase() && !!(a.piano || b.piano);
    case "macro_area":
      return (a.macro_area || "").toString().trim().toUpperCase() === (b.macro_area || "").toString().trim().toUpperCase() && !!(a.macro_area || b.macro_area);
    case "scostamento": {
      const va = a.scostamento; const vb = b.scostamento;
      if (va == null || vb == null) return false;
      return Math.abs(Number(va) - Number(vb)) < 0.001;
    }
    default:
      return false;
  }
};

/**
 * Returns Map<id, { level: 'red' | 'orange', count: number, twins: string[] }>
 * where `twins` is the list of other property ids that triggered the flag.
 */
export const computeDuplicates = (properties) => {
  const result = new Map();
  // Skip properties the user has explicitly flagged as "non-duplicate" so
  // they neither show the flame nor pollute the twin lists of others.
  const active = properties.filter((p) => !p.is_not_duplicate);
  const n = active.length;
  for (let i = 0; i < n; i++) {
    const p = active[i];
    let best = null;
    const twins = { orange: [], red: [] };
    for (let j = 0; j < n; j++) {
      if (i === j) continue;
      const q = active[j];
      let matched = 0;
      for (const f of DUP_FIELDS) if (fieldsMatch(p, q, f)) matched++;
      if (matched >= DUP_FIELDS.length) {
        twins.red.push(q.id);
        if (!best || best.level !== "red" || matched > best.count) {
          best = { level: "red", count: matched, twins: [] };
        }
      } else if (matched >= 3) {
        twins.orange.push(q.id);
        if (!best || (best.level === "orange" && matched > best.count)) {
          best = { level: "orange", count: matched, twins: [] };
        }
      }
    }
    if (best) {
      best.twins = best.level === "red" ? twins.red : twins.orange;
      result.set(p.id, best);
    }
  }
  return result;
};
